// extracted by mini-css-extract-plugin
module.exports = {"font":"Fonts-module--font--1JFqi","selected":"Fonts-module--selected--y5oUJ"};